const TOKEN_KEY = 'opinion_auth_token'
const USER_KEY = 'opinion_auth_user'

export function getAuthToken() {
  return localStorage.getItem(TOKEN_KEY) || ''
}

export function saveAuthSession(session) {
  if (!session || !session.token) {
    clearAuthSession()
    return
  }
  localStorage.setItem(TOKEN_KEY, session.token)
  localStorage.setItem(USER_KEY, JSON.stringify(session))
}

export function loadAuthSession() {
  try {
    const raw = localStorage.getItem(USER_KEY)
    if (!raw) return null
    const session = JSON.parse(raw)
    if (!session || !session.token) return null
    return session
  } catch (error) {
    return null
  }
}

export function clearAuthSession() {
  localStorage.removeItem(TOKEN_KEY)
  localStorage.removeItem(USER_KEY)
}

const ADMIN_TOKEN_KEY = 'opinion_admin_token'
const ADMIN_USER_KEY = 'opinion_admin_user'

export function getAdminAuthToken() {
  return localStorage.getItem(ADMIN_TOKEN_KEY) || ''
}

export function saveAdminAuthSession(session) {
  if (!session || !session.token) {
    clearAdminAuthSession()
    return
  }
  localStorage.setItem(ADMIN_TOKEN_KEY, session.token)
  localStorage.setItem(ADMIN_USER_KEY, JSON.stringify(session))
}

export function loadAdminAuthSession() {
  try {
    const raw = localStorage.getItem(ADMIN_USER_KEY)
    if (!raw) return null
    const session = JSON.parse(raw)
    if (!session || !session.token) return null
    return session
  } catch (error) {
    return null
  }
}

export function clearAdminAuthSession() {
  localStorage.removeItem(ADMIN_TOKEN_KEY)
  localStorage.removeItem(ADMIN_USER_KEY)
}

export function isGroupLeader(user) {
  return !!(user && (user.groupLeader || user.roleCode === 'GROUP_LEADER'))
}

export function buildUserNameMap(user) {
  const map = {}
  if (!user) return map
  ;(user.groupMembers || []).forEach(item => {
    map[item.id] = item.displayName || item.username
  })
  map[user.id] = user.displayName || user.username
  return map
}
